import PptxGenJS from "pptxgenjs";

const convertToInches = function (val: number) {
    return val / 160;
}
const convertToInchesWidth = function (val: number) {
    return val / 96;
}

const printer = function (sequenceObject: any, settingsTime: any, settingswellFluid: any, settingsRig: any, getProjectDatesGetter: any, getProjectDatesGetterStart: any, getProjectDatesGetterEnd: any, getProjectsForYear: any, getProjectsForRig: any, getProjectsForRigless: any) {
    //used for getting month name when running loops
    const monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']
    //used for getting color codes for Rig Terrains
    const terrain_categories: any = {
        Land: settingsRig.find((x:any) => x.propertyName.toLowerCase() === 'land').substring(1),
        Swamp: settingsRig.find((x:any) => x.propertyName.toLowerCase() === 'swamp').substring(1),
        Offshore: settingsRig.find((x:any) => x.propertyName.toLowerCase() === 'offshore').substring(1),
    }
    const terrain_text_categories: any = {
        Land: '000000',
        Swamp: '000000',
        Offshore: '000000',
    }
    const sequenceName = sequenceObject.name;
    const currentDate = new Date();
    //variable used in position calculation
    const margin = convertToInches(30);
    const headerHeight = convertToInches(30);
    const headerLineHeight = convertToInches(10);
    const legendHeight = convertToInches(20);
    const legendWidth = convertToInchesWidth(180);
    const monthNamesHeight = convertToInches(20)
    const heightPerRig = convertToInches(60);
    const rigNamesWidth = convertToInchesWidth(120);
    const rigNameHieght = convertToInches(30)
    const rigTerrainHieght = convertToInches(20)
    const activityHeight = convertToInches(30);
    const activityPaddingTop = convertToInches(0)
    const totalHieght = (2 * margin) + headerHeight + headerLineHeight + legendHeight + (2 * monthNamesHeight) + (sequenceObject.rigs.length * heightPerRig) + (sequenceObject.riglessBuckets.length * heightPerRig)
    // const totalWidth = (totalHieght * 1.4) + (2 * margin);
    const totalWidth = rigNamesWidth * 8
    var chartWidth = totalWidth - (rigNamesWidth + (2 * margin));
    var chartHeight = (sequenceObject.rigs.length * heightPerRig) + (sequenceObject.riglessBuckets.length * heightPerRig)
    var monthNamesWidth = chartWidth / 12
    var weekNameWidth = chartWidth / 48
    var dayWidth = chartWidth / 365
    // this.$store.getters['getProjectDates']
    var numberOfSlides = getProjectDatesGetterEnd - getProjectDatesGetterStart + 2;
    var sequenceStartMonth = getProjectDatesGetter.getMonth()
    var masterObjects: any = [];
    var pptx: any = new PptxGenJS();
    //draw Header
    masterObjects.push({
        'text': {
            text: sequenceName + "- Date Printed: " + currentDate.getDate() + "/" + currentDate.getMonth() + "/" + currentDate.getFullYear(),
            options: {
                x: margin,
                y: margin,
                w: '90%',
                h: headerHeight,
                fontSize: 16,
                bold: true,
                valign: 'middle'
            }
        }
    })
    // draw header Lne
    masterObjects.push({
        'line': {
            x: margin,
            y: margin + headerHeight,
            w: '60%',
            h: 0,
            line: 'FFA500',
            lineSize: 2
        }
    })
    //week boxes and vertical thick lines
    for (let g = 0; g < 12; g++) {
        //start point for each Month
        var startPoint = margin + rigNamesWidth + (g * monthNamesWidth);
        for (let k = 0; k < 4; k++) {
            //start point for each in a month
            var innerStartPoint = startPoint + (weekNameWidth * k)
            //write the number representing each week
            masterObjects.push({
                'text': {
                    text: k + 1,
                    options: {
                        x: innerStartPoint,
                        y: margin + headerHeight + headerLineHeight + legendHeight + monthNamesHeight,
                        w: weekNameWidth,
                        h: monthNamesHeight,
                        align: 'center',
                        fill: settingsTime[2].color.substring(1),
                        fontSize: 8,
                        color: 'FFFFFF',
                        line: {
                            pt: 2,
                            color: 'FFFFFF'
                        }
                    }
                }
            })
            //draw the vertical thick line
            masterObjects.push({
                'line': {
                    x: innerStartPoint,
                    y: margin + headerHeight + headerLineHeight + legendHeight + monthNamesHeight + monthNamesHeight,
                    w: 0,
                    h: chartHeight,
                    line: '808080',
                    lineSize: 1
                }
            })
        }
    }
    // draw the horizontal thicks
    for (let k = 1; k <= sequenceObject.rigs.length + sequenceObject.riglessBuckets.length; k++) {
        masterObjects.push({
            'line': {
                x: margin,
                y: margin + headerHeight + headerLineHeight + legendHeight + monthNamesHeight + monthNamesHeight + (k * heightPerRig),
                w: (totalWidth - (2 * margin)),
                h: 0,
                line: '808080',
                lineSize: 1
            }
        })
    }
    // set the layout
    pptx.defineLayout({
        name: 'DSP',
        width: totalWidth,
        height: totalHieght
    });
    // set the master slide that gets repeated everywhere
    pptx.defineSlideMaster({
        title: "DSPMASTER",
        margin: 1,
        objects: masterObjects
    })
    // create 1 slide for each 12 month periods, add month names first, then add activities for each rig
    for (let i = 0; i < numberOfSlides; i++) {
        var slide = pptx.addSlide("DSPMASTER");
        var currentYear = getProjectDatesGetterStart + i
        // zeros and sequenceStartMonth
        var currentSlideStartDate = new Date(currentYear, 0, 1)
        var currentSlideMaxDate = new Date(currentSlideStartDate.getFullYear() + 1, ((currentSlideStartDate.getMonth() - 1) < 0) ? 11 : (currentSlideStartDate.getMonth() - 1), (currentSlideStartDate.getMonth() - 1) == 1 ? 27 : 30)

        var projectsForThisYear = getProjectsForYear(currentSlideStartDate)
        //draw month names
        for (let g = 0; g < 12; g++) {
            var normalizedMonthCode = ((g + 0) > 11) ? ((g + 0) - 12) : (g + 0)
            var yearToDisplay = ((g + 0) > 11) ? currentYear + 1 : currentYear
            var startPointx = margin + rigNamesWidth + (g * monthNamesWidth);
            slide.addText(monthNames[normalizedMonthCode] + ' ' + "'" + String(yearToDisplay).substring(2, 4), {
                x: startPointx,
                y: margin + headerHeight + headerLineHeight + legendHeight,
                w: monthNamesWidth,
                h: monthNamesHeight,
                align: 'center',
                fontSize: 8,
                fill: settingsTime[0].color.substring(1),
                color: 'FFFFFF',
                line: {
                    pt: 2,
                    color: 'FFFFFF'
                }
            })
        }
        //draw rig names and the projects for each rig        
        // Rigless false
        for (let k = 0; k < sequenceObject.rigs.length; k++) {
            //draw rig names and Terrain
            slide.addText(sequenceObject.rigs[k].name, {
                x: margin,
                y: margin + headerHeight + headerLineHeight + legendHeight + monthNamesHeight + monthNamesHeight + (k * heightPerRig),
                h: heightPerRig,
                w: rigNamesWidth,
                fontSize: 7,
                color: terrain_text_categories[sequenceObject.rigs[k].terrain],
                fill: terrain_categories[sequenceObject.rigs[k].terrain],
                valign: 'middle',
                bold: true
            });
            slide.addText('Terrain: ' + sequenceObject.rigs[k].terrain, {
                x: margin,
                y: margin + headerHeight + headerLineHeight + legendHeight + monthNamesHeight + monthNamesHeight + (k * heightPerRig) + rigNameHieght,
                h: rigTerrainHieght,
                w: rigNamesWidth,
                fontSize: 7,
                color: terrain_text_categories[sequenceObject.rigs[k].terrain],
                valign: 'top'
            });
            var projectsForRig = getProjectsForRig(sequenceObject.rigs[k].id, projectsForThisYear)

            for (let q = 0; q < projectsForRig.length; q++) {
                var projectStartDateRig = new Date(projectsForRig[q].start)
                var projectEndDateRig = new Date(projectsForRig[q].end)
                if (projectStartDateRig > currentSlideMaxDate) {
                    let actualProjectStart = new Date(projectsForRig[q].start)
                    actualProjectStart.setDate(actualProjectStart.getDate() - (projectsForRig[q].rigMoveDays + 1))
                    //get the difference between the nomalized project start date and the chart start date
                    var startTimeDiffRig = Math.abs(actualProjectStart.getTime() - currentSlideStartDate.getTime());
                    //get the difference between the nomalized project start date and the project end date
                    var endTimeDiffRig = Math.abs(currentSlideMaxDate.getTime() - actualProjectStart.getTime());
                    var numberOfDaysToProjectStartRig = Math.ceil(startTimeDiffRig / (1000 * 3600 * 24))
                    var actualRigMoveDaysRig = Math.ceil(endTimeDiffRig / (1000 * 3600 * 24))

                    slide.addText("R/M", {
                        x: margin + rigNamesWidth + (dayWidth * numberOfDaysToProjectStartRig),
                        y: margin + headerHeight + headerLineHeight + legendHeight + monthNamesHeight + monthNamesHeight + (k * heightPerRig) + activityPaddingTop,
                        w: (dayWidth * actualRigMoveDaysRig),
                        h: activityHeight,
                        align: 'center',
                        line: {
                            pt: 2,
                            color: '000000'
                        }
                    });

                } else {
                    //normalizing the project start date, in the case where it is started the previous year
                    if (projectStartDateRig < currentSlideStartDate) {
                        projectStartDateRig = currentSlideStartDate
                    }
                    //normalizing the project end date, in the case where it ends the following year
                    if (projectEndDateRig > currentSlideMaxDate) {
                        projectEndDateRig = currentSlideMaxDate
                    }
                    //get the difference between the nomalized project start date and the chart start date
                    var startTimeDiffxRig = Math.abs(projectStartDateRig.getTime() - currentSlideStartDate.getTime());
                    //get the difference between the nomalized project start date and the project end date
                    var endTimeDiffxRig = Math.abs(projectEndDateRig.getTime() - projectStartDateRig.getTime());
                    //convert the differences above to days
                    var numberOfDaysToProjectStartxRig = startTimeDiffxRig / (1000 * 3600 * 24)
                    var numberOfDaysInProjectxRig = endTimeDiffxRig / (1000 * 3600 * 24)
                    var numberOfDaysToRigMoveRig = numberOfDaysToProjectStartxRig - (projectsForRig[q].rigMoveDays + 1)
                    var actualRigMoveDaysxRig = (projectsForRig[q].rigMoveDays - 1)
                    //drawing Rig Moves
                    if (projectsForRig[q].rigMoveDays != undefined && projectsForRig[q].rigMoveDays != 0 && ((new Date(projectsForRig[q].start)) > currentSlideStartDate)) {
                        let dateOfRigMoveStart = new Date(projectsForRig[q].start)
                        dateOfRigMoveStart.setDate(dateOfRigMoveStart.getDate() - (projectsForRig[q].rigMoveDays + 1))
                        if (dateOfRigMoveStart < currentSlideStartDate) {
                            numberOfDaysToRigMoveRig = 0
                            actualRigMoveDaysxRig = actualRigMoveDaysxRig - Math.ceil((currentSlideStartDate.getTime() - dateOfRigMoveStart.getTime()) / (1000 * 3600 * 24))
                        }
                        if (actualRigMoveDaysxRig > 0) {
                            slide.addText("RM", {
                                x: margin + rigNamesWidth + (dayWidth * numberOfDaysToRigMoveRig),
                                y: margin + headerHeight + headerLineHeight + legendHeight + monthNamesHeight + monthNamesHeight + (k * heightPerRig) + activityPaddingTop,
                                w: (dayWidth * actualRigMoveDaysxRig),
                                h: activityHeight,
                                align: 'center',
                                line: {
                                    pt: 2,
                                    color: '000000'
                                }
                            });
                        }
                    }
                    var colorCodeForProjectRig = "FFA500"
                    if (projectsForRig[q].well == null) {
                        projectsForRig[q].well = {
                            name: "No Well Assigned",
                            wellType: "NONE"
                        }
                    }
                    if (projectsForRig[q].well.wellType == "Gas") {
                        colorCodeForProjectRig = settingswellFluid[2].color.substring(1)
                    } else if (projectsForRig[q].well.wellType == "OilGas") {
                        colorCodeForProjectRig = settingswellFluid[1].color.substring(1)
                    } else if (projectsForRig[q].well.wellType == "Oil") {
                        colorCodeForProjectRig = settingswellFluid[0].color.substring(1)
                    } else if (projectsForRig[q].well.wellType == "Condensate") {
                        colorCodeForProjectRig = settingswellFluid[3].color.substring(1)
                    } else {
                        colorCodeForProjectRig = settingswellFluid[3].color.substring(1)                        
                    }

                    slide.addText(
                        projectsForRig[q].well.name, {
                        x: margin + rigNamesWidth + (dayWidth * (numberOfDaysToProjectStartxRig)) + convertToInches(10),
                        y: margin + (margin / 2) + headerHeight + headerLineHeight + legendHeight + monthNamesHeight + monthNamesHeight + (k * heightPerRig) + activityPaddingTop,
                        h: activityHeight,
                        w: (numberOfDaysInProjectxRig * dayWidth),
                        fontSize: 8,
                        color: 'ffffff',
                        fill: {
                            type: 'solid',
                            color: colorCodeForProjectRig
                        },
                        lineDash: projectsForRig[q].funding == undefined ? '' : projectsForRig[q].funding.lineStyle == 'Dotted' ? 'sysDot' : projectsForRig[q].funding.lineStyle == 'Dashed' ? 'dash' : 'solid',
                        line: {
                            pt: 2,
                            color: projectsForRig[q].funding ? projectsForRig[q].funding.lineColor : colorCodeForProjectRig
                        },
                        align: 'center',
                        valign: 'middle',
                        rectRadius: 10
                    }
                    );

                }
            }
        }




        //Rigless true
        for (let b = 0; b < sequenceObject.riglessBuckets.length; b++) {
            //draw rig names and Terrain
            let riglessStart = sequenceObject.rigs.length * heightPerRig
            let start = (b == 0) ? riglessStart : (sequenceObject.rigs.length+b) * heightPerRig
            slide.addText(sequenceObject.riglessBuckets[b].alias, {
                x: margin,
                y: margin + headerHeight + headerLineHeight + legendHeight + monthNamesHeight + monthNamesHeight + start,
                h: heightPerRig,
                w: rigNamesWidth,
                fontSize: 7,
                color: '000000',
                fill: sequenceObject.riglessBuckets[b].color,
                valign: 'middle',
                bold: true
            });
            slide.addText('Terrain: Rigless', {
                x: margin,
                y: margin + headerHeight + headerLineHeight + legendHeight + monthNamesHeight + monthNamesHeight + start + rigNameHieght,
                h: rigTerrainHieght,
                w: rigNamesWidth,
                fontSize: 7,
                color: '000000',
                valign: 'top'
            });
            var projectsForRigless = getProjectsForRigless(sequenceObject.riglessBuckets[b].id, projectsForThisYear)

            for (let q = 0; q < projectsForRigless.length; q++) {
                var projectStartDate = new Date(projectsForRigless[q].start)
                var projectEndDate = new Date(projectsForRigless[q].end)
                if (projectStartDate > currentSlideMaxDate) {
                    let actualProjectStart = new Date(projectsForRigless[q].start)
                    actualProjectStart.setDate(actualProjectStart.getDate() - (projectsForRigless[q].rigMoveDays + 1))
                    //get the difference between the nomalized project start date and the chart start date
                    var startTimeDiff = Math.abs(actualProjectStart.getTime() - currentSlideStartDate.getTime());
                    //get the difference between the nomalized project start date and the project end date
                    var endTimeDiff = Math.abs(currentSlideMaxDate.getTime() - actualProjectStart.getTime());
                    var numberOfDaysToProjectStart = Math.ceil(startTimeDiff / (1000 * 3600 * 24))
                    var actualRigMoveDays = Math.ceil(endTimeDiff / (1000 * 3600 * 24))

                    slide.addText("R/M", {
                        x: margin + rigNamesWidth + (dayWidth * numberOfDaysToProjectStart),
                        y: margin + headerHeight + headerLineHeight + legendHeight + monthNamesHeight + monthNamesHeight + start + activityPaddingTop,
                        w: (dayWidth * actualRigMoveDays),
                        h: activityHeight,
                        align: 'center',
                        line: {
                            pt: 2,
                            color: '000000'
                        }
                    });

                } else {
                    //normalizing the project start date, in the case where it is started the previous year
                    if (projectStartDate < currentSlideStartDate) {
                        projectStartDate = currentSlideStartDate
                    }
                    //normalizing the project end date, in the case where it ends the following year
                    if (projectEndDate > currentSlideMaxDate) {
                        projectEndDate = currentSlideMaxDate
                    }
                    //get the difference between the nomalized project start date and the chart start date
                    var startTimeDiffx = Math.abs(projectStartDate.getTime() - currentSlideStartDate.getTime());
                    //get the difference between the nomalized project start date and the project end date
                    var endTimeDiffx = Math.abs(projectEndDate.getTime() - projectStartDate.getTime());
                    //convert the differences above to days
                    var numberOfDaysToProjectStartx = startTimeDiffx / (1000 * 3600 * 24)
                    var numberOfDaysInProjectx = endTimeDiffx / (1000 * 3600 * 24)
                    var numberOfDaysToRigMove = numberOfDaysToProjectStartx - (projectsForRigless[q].rigMoveDays + 1)
                    var actualRigMoveDaysx = (projectsForRigless[q].rigMoveDays - 1)
                    //drawing Rig Moves
                    if (projectsForRigless[q].rigMoveDays != undefined && projectsForRigless[q].rigMoveDays != 0 && ((new Date(projectsForRigless[q].start)) > currentSlideStartDate)) {
                        let dateOfRigMoveStart = new Date(projectsForRigless[q].start)
                        dateOfRigMoveStart.setDate(dateOfRigMoveStart.getDate() - (projectsForRigless[q].rigMoveDays + 1))
                        if (dateOfRigMoveStart < currentSlideStartDate) {
                            numberOfDaysToRigMove = 0
                            actualRigMoveDaysx = actualRigMoveDaysx - Math.ceil((currentSlideStartDate.getTime() - dateOfRigMoveStart.getTime()) / (1000 * 3600 * 24))
                        }
                        if (actualRigMoveDaysx > 0) {
                            slide.addText("RM", {
                                x: margin + rigNamesWidth + (dayWidth * numberOfDaysToRigMove),
                                y: margin + headerHeight + headerLineHeight + legendHeight + monthNamesHeight + monthNamesHeight + start + activityPaddingTop,
                                w: (dayWidth * actualRigMoveDaysx),
                                h: activityHeight,
                                align: 'center',
                                line: {
                                    pt: '2',
                                    color: '000000'
                                }
                            });
                        }
                    }
                    var colorCodeForProject = "FFA500"
                    if (projectsForRigless[q].well == null) {
                        projectsForRigless[q].well = {
                            name: "No Well Assigned",
                            wellType: "NONE"
                        }
                    }
                    if (projectsForRigless[q].well.wellType == "Gas") {
                        colorCodeForProject = settingswellFluid[2].color.substring(1)
                    }
                    if (projectsForRigless[q].well.wellType == "OilGas") {
                        colorCodeForProject = settingswellFluid[1].color.substring(1)
                    }
                    if (projectsForRigless[q].well.wellType == "Oil") {
                        colorCodeForProject = settingswellFluid[0].color.substring(1)
                    }
                    if (projectsForRigless[q].well.wellType == "Condensate") {
                        colorCodeForProject = settingswellFluid[3].color.substring(1)
                    }

                    slide.addText(
                        projectsForRigless[q].well.name, {
                        x: margin + rigNamesWidth + (dayWidth * (numberOfDaysToProjectStartx)) + convertToInches(10),
                        y: margin + (margin / 2) + headerHeight + headerLineHeight + legendHeight + monthNamesHeight + monthNamesHeight + start + activityPaddingTop,
                        h: activityHeight,
                        w: (numberOfDaysInProjectx * dayWidth),
                        fontSize: 8,
                        color: 'ffffff',
                        fill: {
                            type: 'solid',
                            color: colorCodeForProject,
                            alpha: projectsForRigless[q].activities.length > 0 ? 100 : 0
                        },
                        lineDash: projectsForRigless[q].funding == undefined ? '' : projectsForRigless[q].funding.lineStyle == 'Dotted' ? 'sysDot' : projectsForRigless[q].funding.lineStyle == 'Dashed' ? 'dash' : 'solid',
                        line: {
                            pt: 2,
                            color: projectsForRigless[q].funding ? projectsForRigless[q].funding.lineColor : colorCodeForProject
                        },
                        align: 'center',
                        valign: 'middle',
                        rectRadius: 10
                    }
                    );

                }
            }

        }
    }
    var pptName = sequenceName + "(" + currentDate.getDay() + "-" + currentDate.getMonth() + "-" + currentDate.getFullYear() + ")"
    pptx.writeFile(pptName);
}

export default printer